import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import router from '@/router';
import '@tencent/bk-icon-tys';
import '@tencent/bk-icon-tys-admin';
import '@/assets/styles/app.less';

const App: FC = () => {
  const outlet = useRoutes(router);

  return <>
    {outlet}
  </>;
};

export default App;
